<template>
  <div class="trademark">
    Siemens Energy is a trademark licensed by Siemens AG.<br />
    © Siemens Energy, 2025
  </div>
</template>

<script>
export default {
  name: 'EMTrademarkInfo',
};
</script>
<style scoped>
.trademark {
    background-color: white;
    font-size: 0.8125rem;
    font-weight: 400;
    padding: 10px;
}
</style>
